module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1023-35cdf12480ad2c006d8f34dffa35ed97.png";